export const getFormattedDate = (dateString: string) => {
  const date = new Date(dateString)
  return date.toLocaleDateString(undefined, { year: "numeric", month: "2-digit", day: "2-digit", timeZone: "UTC" })
}
